module.exports = __webpack_public_path__ + "img/pic_2_1.74b09813.jpg";